const config = {
    API_URL: process.env.REACT_APP_API_URL,
    PARENT_APP: process.env.REACT_APP_PARENT_APP,
    EXTENDED_API_URL: process.env.REACT_APP_EXTENDED_API_URL,
    img_URL: process.env.REACT_APP_IMG_URL,
};

export default config;
